import React from "react";

// Styles
import ReportsTabContainer from "./ReportsTab.styles";
import PowerBIDashboard from "../../../../Common/PowerBIDashboard";

interface ReportsTabProps {
    reportId: string;
    workspaceId: string;
}

const ReportsTab = ({ reportId, workspaceId }: ReportsTabProps) => {
    return (
        <ReportsTabContainer>
            {reportId !== "" ? (
                <div className="iframeContainer">
                    <PowerBIDashboard
                        reportId={reportId}
                        workspaceId={workspaceId}
                    ></PowerBIDashboard>
                </div>
            ) : (
                <p>PowerBI dashboard not specified.</p>
            )}
        </ReportsTabContainer>
    );
};
export default ReportsTab;
